// noinspection JSUnresolvedReference

import React, { memo } from 'react'
import './styles.scss'
import PropTypes from 'prop-types'
import TableRowGroup from '../../../Shared/Table/TableRowGroup'
import TableRow from '../../../Shared/Table/TableRow'
import TableData from '../../../Shared/Table/TableData'
import CollapsibleTrigger from '../../../Shared/Collapsible/CollapsibleTrigger'
import Stars from '../../../Shared/Stars'
import { Trans, useTranslation } from 'react-i18next'
import TableHead from '../../../Shared/Table/TableHead'
import Table from '../../../Shared/Table'

const TourOperatorsList = ({ tourOperators, onOfferSelected }) => {
  const { t } = useTranslation()
  return (
    <div>
      <CollapsibleTrigger className={'CollapseAll'} for={'offer'}
                          openText={t('COLLAPSIBLE_OPEN_ALL')}><Trans>COLLAPSIBLE_CLOSE_ALL</Trans></CollapsibleTrigger>
      <Table className={'TableTourOperator'}>
        <TableRow>
          <TableHead width="1"><Trans>TABLE_HEAD_PRODUCT_CODE</Trans></TableHead>
          <TableHead width="200"><Trans>TABLE_HEAD_CATALOG</Trans></TableHead>
          <TableHead><Trans>TABLE_HEAD_HOTEL_NAME</Trans></TableHead>
          <TableHead width="80">
            <center><Trans>TABLE_HEAD_IMAGES</Trans></center>
          </TableHead>
          <TableHead width="80"><Trans>TABLE_HEAD_CATEGORY</Trans></TableHead>
          <TableHead width="150"><Trans>TABLE_HEAD_CITY</Trans></TableHead>
          <TableHead width="150"><Trans>TABLE_HEAD_DESTINATION</Trans></TableHead>
          <TableHead width="100"><Trans>TABLE_HEAD_COUNTRY</Trans></TableHead>
          <TableHead width="1"></TableHead>
        </TableRow>
        {tourOperators.tourOperators.map((operator) => (
          <TableRowGroup key={operator.id}>
            <TableRow>
              <TableData>
                <img alt={'logo' + operator.name} src={operator.logo}/>
              </TableData>
              <TableData>
                <h4>
                  {operator.push &&
                    <span className="TableTourOperator-Push">Push</span>
                  }
                  {operator.name}
                </h4>
              </TableData>
              <TableData></TableData>
              <TableData></TableData>
              <TableData></TableData>
              <TableData></TableData>
              <TableData></TableData>
              <TableData></TableData>
              <TableData>
                <CollapsibleTrigger for={'offer_' + operator.id}></CollapsibleTrigger>
              </TableData>
            </TableRow>
            {operator.offers.map((offer) => (
              <TableRow className={'offer offer_' + operator.id} key={offer.offerId}>
                <TableData>
                  <span className={'Link'} onClick={() => onOfferSelected(operator, offer)}>
                    {offer.bookingCodes[0]}
                  </span>
                </TableData>
                <TableData>{offer.catalogName}</TableData>
                <TableData>{offer.name}</TableData>
                <TableData className="TableData_Highlight">
                  <center>{offer.imageCount}</center>
                </TableData>
                <TableData className='StarData'>
                  <Stars count={offer.rating}></Stars>
                </TableData>
                <TableData className="CenteredText">{offer.cityName}</TableData>
                <TableData className="CenteredText">{offer.destinationName}</TableData>
                <TableData className="CenteredText">{offer.countryName}</TableData>
                <TableData></TableData>
              </TableRow>
            ))}
          </TableRowGroup>
        ))}
      </Table>
    </div>
  )
}

TourOperatorsList.propTypes = {
  tourOperators: PropTypes.object.isRequired,
  onOfferSelected: PropTypes.func.isRequired,
}

export default memo(TourOperatorsList)
